import { addressValidation, AddressValidationDeps } from 'lib/core/data/schema'

export interface ShippingAddressFormValues {
  firstName: string
  lastName: string
  company: string
  countryCode: string
  regionCode: string
  street: string
  street2: string
  city: string
  postalCode: string
  phoneNumber: string
}

export const shippingAddressFormSchema = {
  firstName: '',
  lastName: '',
  company: '',
  countryCode: '',
  regionCode: '',
  street: '',
  street2: '',
  city: '',
  postalCode: '',
  phoneNumber: ''
}

export const shippingAddressFormValidation = (deps: AddressValidationDeps) => {
  const schema = addressValidation(deps)
  return schema
}
